import { getPrioritizedImages } from '@components/app/TrialSummaryCard/getPrioritizedImages'
import { CloudflareImage } from '@components/primitives/Image/Cloudflare'
import type { TrialLocationNarrow } from '@modules/trials/types/TrialAssociatedWithLocations'

export const FacilityPhotoCollage = ({
  closestSite,
}: {
  closestSite: TrialLocationNarrow
}) => {
  const alt = `Image of ${closestSite.facility} in ${closestSite.city}, ${closestSite.country}.`

  const allImages = getPrioritizedImages(closestSite.images, closestSite.id)

  if (allImages.length === 0) {
    return null
  }

  if (allImages.length === 1) {
    return (
      <CollageContainer>
        <CloudflareImage
          alt={alt}
          className='w-full'
          imageId={allImages[0]?.externalId ?? ''}
        />
      </CollageContainer>
    )
  }

  if (allImages.length === 2) {
    return (
      <CollageContainer>
        <CloudflareImage
          alt={alt}
          className='w-2/3'
          imageId={allImages[0]?.externalId ?? ''}
        />
        <CloudflareImage alt={alt} imageId={allImages[1]?.externalId ?? ''} />
      </CollageContainer>
    )
  }

  return (
    <CollageContainer>
      <CloudflareImage
        alt={alt}
        className='w-1/2'
        imageId={allImages[0]?.externalId ?? ''}
      />
      <CloudflareImage
        alt={alt}
        className='w-1/4'
        imageId={allImages[1]?.externalId ?? ''}
      />
      <CloudflareImage
        alt={alt}
        className='w-1/4'
        imageId={allImages[2]?.externalId ?? ''}
      />
    </CollageContainer>
  )
}

const CollageContainer = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className='flex h-[256px] w-full gap-2 overflow-hidden rounded-2xl'>
      {children}
    </div>
  )
}
